import { HttpMethod } from '@pool-league/shared-util-http';
import {
  PostOperation,
  EndpointPathParameters,
  GetOperation,
} from '../operation';

export const KILLER_START_SESSION: PostOperation<void> = {
  path: ['killer'],
  method: HttpMethod.POST,
};
export type KillerEndSessionPathParameters = EndpointPathParameters<'seasonId'>;
export const KILLER_END_SESSION: GetOperation<
  keyof KillerEndSessionPathParameters
> = {
  path: ['seasons', { param: 'seasonId' } /* TODO */],
  method: HttpMethod.GET,
};

export const KILLER_GET_SESSION_ID: GetOperation<void> = {
  path: ['killer'],
  method: HttpMethod.GET,
};
